/* =========================================================
   CQL WEB PERMISSIONS
   Mirrors WWS cql.web_permissions behavior in SKY while preserving
   SKY's existing button/font/color classes.
   ========================================================= */

(function () {
  'use strict';

  function initWebPermissions() {
    var config = document.getElementById('CqlWebPermissionsConfig');

    if (!config) {
      return;
    }

    var permission = (config.getAttribute('data-permission') || '').toLowerCase();
    var findStoreUrl = config.getAttribute('data-find-store-url') || '/pages/locations';
    var phone = config.getAttribute('data-call-for-price-phone') || '';

    var isInStoreOnly = permission === 'instoreonly';
    var isInStoreHidePrice = permission === 'instoreonly,hideprice';
    var isHidePrice = permission === 'hideprice';
    var shouldFindInStore = isInStoreOnly || isInStoreHidePrice || isHidePrice;
    var shouldHidePrice = isInStoreHidePrice || isHidePrice;

    if (!shouldFindInStore && !shouldHidePrice) {
      return;
    }

    if (shouldHidePrice) {
      insertCallForPrice(phone);
      hideInstallmentMessaging();
    }

    if (shouldFindInStore) {
      convertBuyButtonsToFindInStore(findStoreUrl);
    }
  }

  function insertCallForPrice(phone) {
    if (document.getElementById('Product-Price-In-Cart')) {
      return;
    }

    var normalPrice = document.querySelector('.product-price');
    var priceAnchor = normalPrice || document.getElementById('Product-Price');

    if (!priceAnchor || !priceAnchor.parentNode) {
      return;
    }

    var price = document.createElement('span');
    price.id = 'Product-Price-In-Cart';
    price.setAttribute('data-calltrk-noswap', '');
    price.textContent = 'Call for price:' + (phone ? ' ' + phone : '');

    if (normalPrice) {
      normalPrice.parentNode.insertBefore(price, normalPrice);
    } else {
      priceAnchor.parentNode.insertBefore(price, priceAnchor);
    }
  }

  function hideInstallmentMessaging() {
    var selectors = [
      '[data-shopify="payment-terms"]',
      '.shopify-payment-terms',
      '.shopify-installments',
      'shopify-payment-terms'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        element.style.display = 'none';
      });
    });
  }

  function convertBuyButtonsToFindInStore(findStoreUrl) {
    var forms = document.querySelectorAll('#AddToCartForm, form.product-form');

    forms.forEach(function (form) {
      var button = form.querySelector('#AddToCart, button[name="add"]');

      if (!button) {
        return;
      }

      function enforceFindInStoreButton() {
        if (button.type !== 'button') {
          button.type = 'button';
        }
        if (button.disabled) {
          button.disabled = false;
        }
        if (button.hasAttribute('disabled')) {
          button.removeAttribute('disabled');
        }
        if (button.hasAttribute('name')) {
          button.removeAttribute('name');
        }
        if (button.classList.contains('disabled')) {
          button.classList.remove('disabled');
        }
        if (!button.classList.contains('cql-find-in-store')) {
          button.classList.add('cql-find-in-store');
        }
        if (button.getAttribute('aria-disabled') !== 'false') {
          button.setAttribute('aria-disabled', 'false');
        }

        var text = button.querySelector('#AddToCartText') || button.querySelector('span');
        if (text) {
          if (text.textContent.trim() !== 'FIND IN STORE') {
            text.textContent = 'FIND IN STORE';
          }
        } else if (button.textContent.trim() !== 'FIND IN STORE') {
          button.textContent = 'FIND IN STORE';
        }
      }

      enforceFindInStoreButton();

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = findStoreUrl;
      });

      /* Prevent variant scripts from turning the button back into BUY NOW/OOS. */
      var observer = new MutationObserver(function () {
        enforceFindInStoreButton();
      });

      observer.observe(button, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'class', 'type', 'name']
      });

      /* Final guard against form submission. */
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        window.location.href = findStoreUrl;
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWebPermissions);
  } else {
    initWebPermissions();
  }
})();
